/**
 * Class StickyHeader
 */
define([
    'jquery',
    'debounce'
], (
    $ , debounce  
) => {
    class StickyHeader {

        /**
         * Constructor
         *
         * @param {Object}  config  Configuration options passed in through JSON
         * @param {Element} element The element that this class was bound to
         *
         * @returns {null}
         */
        constructor(config, element) {
            const defaultConfig = {};
            // Merge default config options and provided config
            /** @type {Object} */
            this.config = { ...defaultConfig, ...config }; 
            this.lastScrolledPosY = 0;
            this.initStickyHeader();
        }

        /**
         * On scroll adding the sticky_header class to the body element
         *
         * @returns {null}
         */

        initStickyHeader() {
            $(window).on("scroll",this.onScroll);
        }

        onScroll = (e) => {
            const y = $(e.target).scrollTop();
             /* 14 is the minimum vertical scroll distance before the header be sticky */
            if (y >= 14)  {
                $("body").addClass("sticky-header");
            }
            
            else {
                $("body").removeClass("sticky-header");
            }

            let lastPosY = this.lastScrolledPosY;

            $('body').toggleClass('scroll-up' , lastPosY > y && y > 25);
            $('body').toggleClass('scroll-down' , lastPosY < y && y > 25);

            this.lastScrolledPosY = y;
        }       
    }

    return (config, element) => {
        const stickyHeader = new StickyHeader(config, element);
        return stickyHeader;
    };
});




